const subwayTextLineCountOptions = {
  ALL_LINES: "subwayTextLines_ALL",
  THREE_LINES: "subwayTextLines_THREE",
  TWO_LINES: "subwayTextLines_TWO",
  ONE_LINE: "subwayTextLines_ONE",
  NO_LINES: "subwayTextLines_NONE"
};

export default subwayTextLineCountOptions;

export const numericLimitForSubwayTextLineCount = value => {
  switch (value) {
    case subwayTextLineCountOptions.ALL_LINES:
      return null;
    case subwayTextLineCountOptions.THREE_LINES:
      return 3;
    case subwayTextLineCountOptions.TWO_LINES:
      return 2;
    case subwayTextLineCountOptions.ONE_LINE:
      return 1;
    case subwayTextLineCountOptions.NO_LINES:
      return 0;
  }
};

export const shortLabelForSubwayTextLineCount = value => {
  switch (value) {
    case subwayTextLineCountOptions.ALL_LINES:
      return "All";
    case subwayTextLineCountOptions.THREE_LINES:
      return "3";
    case subwayTextLineCountOptions.TWO_LINES:
      return "2";
    case subwayTextLineCountOptions.ONE_LINE:
      return "1";
    case subwayTextLineCountOptions.NO_LINES:
      return "0";
  }
};

export const labelForSubwayTextLineCount = value => {
  switch (value) {
    case subwayTextLineCountOptions.ALL_LINES:
      return "All text";
    case subwayTextLineCountOptions.THREE_LINES:
      return "Max 3 lines";
    case subwayTextLineCountOptions.TWO_LINES:
      return "Max 2 lines";
    case subwayTextLineCountOptions.ONE_LINE:
      return "Max 1 line";
    case subwayTextLineCountOptions.NO_LINES:
      return "No text";
  }
};

export const iconForSubwayTextLineCount = value => {
  switch (value) {
    case subwayTextLineCountOptions.ALL_LINES:
      return "footerSubwayLinesAll";
    case subwayTextLineCountOptions.THREE_LINES:
      return "footerSubwayLines3";
    case subwayTextLineCountOptions.TWO_LINES:
      return "footerSubwayLines2";
    case subwayTextLineCountOptions.ONE_LINE:
      return "footerSubwayLines1";
    case subwayTextLineCountOptions.NO_LINES:
      return "footerSubwayLines0";
  }
};

const createSubwayDisplayDropdownOption = id => {
  return {
    identifier: id,
    name: labelForSubwayTextLineCount(id)
  };
};

export const SubwayTextLineCountDropdownOptions = [
  createSubwayDisplayDropdownOption(subwayTextLineCountOptions.ALL_LINES),
  createSubwayDisplayDropdownOption(subwayTextLineCountOptions.THREE_LINES),
  createSubwayDisplayDropdownOption(subwayTextLineCountOptions.TWO_LINES),
  createSubwayDisplayDropdownOption(subwayTextLineCountOptions.ONE_LINE),
  createSubwayDisplayDropdownOption(subwayTextLineCountOptions.NO_LINES)
];
